module.exports = __webpack_public_path__ + "60d15ae051eb5742e2ade0adbb23bd71.png";